"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSporeConfigHash = void 0;
const base_1 = require("@ckb-lumos/base");
const helpers_1 = require("../helpers");
const configHashStore = new Map();
/**
 * Get the hash of a SporeConfig, calculated by the JSON string of the config.
 * Generated hashes will be stored in cache to save time for later searching.
 */
function getSporeConfigHash(config) {
    const string = JSON.stringify(config, null, 0);
    if (configHashStore.has(string)) {
        return configHashStore.get(string);
    }
    const hash = base_1.utils.ckbHash((0, helpers_1.bytifyRawString)(string));
    configHashStore.set(string, hash);
    return hash;
}
exports.getSporeConfigHash = getSporeConfigHash;
//# sourceMappingURL=hash.js.map